<div class="bg-col-51">
  @if (content) {
    <div class="wrap p-t-16 p-b-16 p-t-4-s p-t-4-m p-b-4-s p-b-4-m"
      [ngClass]="{'flex-x flex-l' : !hasImageGallery}"
      >
      <div class="c-3 c-12-s c-12-m m-b-0 m-r-0-s m-r-0-m p-t-8-s p-t-8-m"
        [ngClass]="{'p-t-16' : hasImageGallery}">
        <p class="o1 col-11"
        *iCms="'subtitle' of content"></p>
        <p class="col-1 m-t-1"
          sizeClass="XL:h3, SM:h4"
        *iCms="'title' of content"></p>
        <action class="button-1 m-t-2 p-r p-l"
          [iCmsModalOpen]="'ugcImageForm'"
          [iCmsModalOpenData]="product">
          <span *iCms="'cta' of content"></span>
        </action>
      </div>
      <div class="c-9 c-12-s c-12-m m-r-0 m-b-0 flex-middle"
        [ngClass]="{'center-x center-l flex-x flex-l' : !hasImageGallery}">
        @if (images?.length) {
          <carousel class="block m-t-6-s m-t-6-m"
            [slidesPerView]="[1.5, 3.12, 3.12, 3.12][client.sizeId]"
            [navigation]="false"
            [spaceBetween]="20"
            [scrollbar]="false"
            [pagination]="false"
            imageViewRoot>
            @for (item of images; track trackByImageId($index, item)) {
              <ng-template swiperSlide>
                <div class="cursor-pointer"
                  iCmsModalOpen="image-zoom-modal"
                  [iCmsModalOpenData]="item.data.image">
                  <div class="ratio-1-1 overflow-hidden">
                    <local-shell />
                    <img class="rf b-radius-max"
                      [options]="{fitIn: true}"
                      [image]="item.data.image" />
                  </div>
                  @if (item.data?.user_tag) {
                    <p class="p2 m-t-2 col-12"
                    >{{item.data.user_tag}}</p>
                  }
                </div>
              </ng-template>
            }
          </carousel>
        }
        @if (!hasImageGallery) {
          <p class="w-10 w-12-m w-11-s col-11 m-t-10-m m-t-10-s p-b-8-s p1"
          *iCms="'message' of content; content: 'html'; skipEmpty: true"></p>
        }
      </div>
    </div>
  }
</div>
